import React from "react";
import { CompontHeader } from "./compont-header";
import { Impressum } from "./impressum";

export const Contact: React.FC = () => {
  return (
    <div
      id="contact"
      className="pt-[84px] mx-auto w-full max-w-7xl h-[calc(100vh-40px)] px-4 flex flex-col"
    >
      {/* Header und Beschreibung */}
      <div className="pb-6">
        <CompontHeader text="Kontaktiere uns" />
      </div>
      <p className="text-center text-3xl pb-6">Kontakt für alle Anfragen</p>

      {/* <div className="flex flex-col md:flex-row justify-evenly gap-8 mb-10"> */}
      <div className="grid grid-cols-1 lg:grid-cols-3 justify-evenly gap-8 mb-10">
        {/* Öffnungszeiten */}
        <div className="text-center lg:text-left">
          <CompontHeader text="Öffnungszeiten" />
          <p className="text-xl font-bold mt-2">
            <span>
              Montag - Ruhetag
              <br />
              Dienstag - Samstag 11:00 - 23:00 Uhr
              <br />
              Sonn- & Feiertage 12:00 - 22:00 Uhr
              <br />
              Winterzeit bis 22:00 Uhr
            </span>
          </p>
        </div>

        {/* Telefon */}
        <div className="text-center">
          <CompontHeader text="Kontakt" />
          <p className="text-xl font-bold mt-2">
            <a href="tel:info@schmeckt-lecker.net" className="hover:underline">
              +49 (0) 2903 449793
            </a>
            <br />
            <a
              href="mailto:info@schmeckt-lecker.net"
              className="hover:underline"
            >
              info@schmeckt-lecker.net
            </a>
          </p>
        </div>

        {/* E-Mail */}
        {/* <div className="text-center">
          <CompontHeader text="Email" />
          <p className="text-xl font-bold mt-2">
            <a
              href="mailto:info@schmeckt-lecker.net"
              className="hover:underline"
            >
              info@schmeckt-lecker.net
            </a>
          </p>
        </div> */}

        {/* Adresse */}
        <div className="text-center  lg:text-right">
          <CompontHeader text="Anschrift" />
          <p className="text-xl font-bold mt-2">
            <a
              href="https://www.google.de/maps/place/T%C3%BCrkischer+Imbiss+%22Schmeckt+lecker!%22/@51.3704193,8.1677996,402m/data=!3m1!1e3!4m6!3m5!1s0x47bbe0c44fe030c9:0x6960d7710d0078a6!8m2!3d51.3703559!4d8.1699654!16s%2Fg%2F11cn2v91dd?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoJLDEwMjExMjM0SAFQAw%3D%3D"
              target="_blank"
              className="hover:underline"
            >
              Bahnhofstraße 40
              <br />
              59872 Meschede
              <br />
              Deutschland
            </a>
          </p>
        </div>
      </div>

      {/* Google Map */}
      <div className="flex-grow flex justify-center">
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3258.578690114717!2d8.167819867839656!3d51.37027054980695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bbe0c44fe030c9%3A0x6960d7710d0078a6!2sT%C3%BCrkischer%20Imbiss%20%22Schmeckt%20lecker*21%22!5e1!3m2!1sde!2sde!4v1734618138033!5m2!1sde!2sde"
          className="w-full max-w-4xl h-full border-0 rounded-lg"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
};
